import yaml from 'js-yaml';

/**
 * Harness localhost YAML entry: feature name -> { treatment, optional keys }.
 * When keys is absent, treatment applies to all users. When keys is present, only those keys get the treatment.
 */
interface SplitYamlEntry {
  treatment: string;
  keys?: string[];
}

type SplitYamlRaw = Array<Record<string, SplitYamlEntry>>;

/**
 * Parses Harness localhost format YAML and returns a features map for the given user.
 * Format: list of - feature_name: { treatment: "on"|"off", keys?: ["uuid"] }.
 * Without keys = default for any key. With keys = only those keys get this treatment (others get 'control').
 */
export function parseSplitYaml(yamlText: string, userUuid: string): Record<string, string> {
  const parsed = yaml.load(yamlText) as SplitYamlRaw | undefined;
  if (!Array.isArray(parsed)) {
    return {};
  }

  const features: Record<string, string> = {};
  for (const item of parsed) {
    for (const [featureName, config] of Object.entries(item)) {
      if (!config || typeof config !== 'object' || typeof config.treatment !== 'string') {
        continue;
      }

      const keys = config.keys;
      if (!keys || !Array.isArray(keys)) {
        features[featureName] = config.treatment;
      } else if (keys.includes(userUuid)) {
        features[featureName] = config.treatment;
      } else {
        features[featureName] = 'control';
      }
    }
  }

  return features;
}
